if (typeof EstimatedDeliveryDates === 'undefined') {
    if (!customElements.get('estimated-delivery-dates')) {
        class EstimatedDeliveryDates extends HTMLElement {
            constructor() {
                super();
                this.items = this.querySelectorAll('.estimated-delivery-dates__item');
                this.mainSection = this.closest("[data-section-type='product']");
                this.variantsInventory = JSON.parse(this.querySelector('[data-variants-inventory]').innerHTML);
                this.selectedOrFirstAvailableVariantId = this.dataset.selectedOrFirstAvailableVariantId;
                this.showEstimatedDeliveryDatesCartItem = this.dataset.showEstimatedDeliveryDatesCartItem === 'true';
            }

            connectedCallback() {
                if (this.mainSection) {
                    this.mainSection.addEventListener('variant:changed', this.handleVariantChanged.bind(this));
                    this.handleVariantChanged({ detail: { variant: { id: this.selectedOrFirstAvailableVariantId } } });
                } else {
                    this.updateVisibility();
                }
            }

            handleVariantChanged(event) {
                const eventDetail = event.detail;
                let variantId = eventDetail?.variant?.id;

                if (!variantId) return;

                this.hideUI();

                variantId = parseInt(variantId);
                if (isNaN(variantId)) return;

                const variantInventory = this.variantsInventory.variants.find(variant => variant.id === variantId);

                if (!variantInventory) return;

                this.items.forEach(item => {
                    const start = parseInt(item.dataset.start);
                    const end = parseInt(item.dataset.end);

                    if (!isNaN(start) && !isNaN(end) && variantInventory.inventory_quantity >= start && variantInventory.inventory_quantity <= end) {
                        item.classList.add('active');
                    } else if (isNaN(start) && !isNaN(end) && variantInventory.inventory_quantity <= end) {
                        item.classList.add('active');
                    } else if (!isNaN(start) && isNaN(end) && variantInventory.inventory_quantity >= start) {
                        item.classList.add('active');
                    }
                });

                this.updateVisibility();
            }

            hideUI() {
                this.items.forEach(item => {
                    item.classList.remove('active');
                });

                this.updateVisibility();
            }

            updateVisibility() {
                this.deduplicateByTitle();

                const activeItems = Array.from(this.querySelectorAll('.estimated-delivery-dates__item.active'));

                if (!activeItems.length) {
                    this.classList.remove('active');
                    this.removeHiddenInput();
                    return;
                }

                this.classList.add('active');
                this.syncHiddenInput(activeItems);
            }

            deduplicateByTitle() {
                const activeItemsByTitle = {};

                this.items.forEach(item => {
                    if (!item.classList.contains('active')) return;

                    const title = item.dataset.title;
                    if (!title) return;

                    if (!activeItemsByTitle[title]) {
                        activeItemsByTitle[title] = [];
                    }
                    activeItemsByTitle[title].push(item);
                });

                Object.keys(activeItemsByTitle).forEach(title => {
                    const itemsWithSameTitle = activeItemsByTitle[title];
                    if (itemsWithSameTitle.length <= 1) return;

                    let highestMinimumDate = -Infinity;
                    let itemToKeep = null;

                    itemsWithSameTitle.forEach(item => {
                        const minimumDate = parseInt(item.dataset.minimumDate);
                        if (!isNaN(minimumDate)) {
                            if (minimumDate > highestMinimumDate) {
                                highestMinimumDate = minimumDate;
                                itemToKeep = item;
                            }
                        } else if (itemToKeep === null) {
                            itemToKeep = item;
                        }
                    });

                    if (itemToKeep) {
                        itemsWithSameTitle.forEach(item => {
                            if (item !== itemToKeep) {
                                item.classList.remove('active');
                            }
                        });
                    }
                });
            }

            syncHiddenInput(activeItems) {
                if (!this.showEstimatedDeliveryDatesCartItem) return;

                const propertyName = this.dataset.estimatedDeliveryDatesPropertyName || 'Livrare';
                const propertyPrefix = `${propertyName}:`;

                const values = activeItems
                    .map(item => item.textContent.trim())
                    .map(value => {
                        if (value.toLowerCase().startsWith(propertyPrefix.toLowerCase())) {
                            return value.slice(propertyPrefix.length).trim();
                        }

                        return value;
                    })
                    .filter(Boolean);

                if (!values.length) {
                    this.removeHiddenInput();
                    return;
                }

                const value = values.join(';');
                let hiddenInput = this.querySelector(`input[name="properties[${propertyName}]"]`);

                if (!hiddenInput) {
                    hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.name = `properties[${propertyName}]`;
                    this.appendChild(hiddenInput);
                }

                hiddenInput.value = value;
            }

            removeHiddenInput() {
                if (!this.showEstimatedDeliveryDatesCartItem) return;

                const hiddenInput = this.querySelector(`input[name="properties[${this.dataset.estimatedDeliveryDatesPropertyName || 'Livrare'}]"]`);

                if (hiddenInput) {
                    hiddenInput.remove();
                }
            }
        }
        customElements.define('estimated-delivery-dates', EstimatedDeliveryDates);
    }
}